import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './sass/app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/index';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorProvider } from './contexts/ErrorContext';

// Создаем клиент React Query
const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <ErrorProvider>
    <Provider store={store}>
      <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App/>
       </QueryClientProvider>
      </BrowserRouter>
    </Provider>
    </ErrorProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
